import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { isMobile } from "../App/utils";

export function WarningDialog({ title, content, onClose, buttonName, logout }) {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
        if (onClose) onClose();
    };


    return (
        <div>
            <Dialog open={open} fullWidth maxWidth={isMobile ? 'xs' : 'sm'} style={{ zIndex: 99999 }}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    {content}
                </DialogContent>
                <DialogActions>
                    {onClose && <Button onClick={handleClose} color="primary">
                        {buttonName}
                    </Button>}
                    {!onClose && <Button onClick={() => logout({fromLogoutButton: true})} color="primary">
                        Logout
                    </Button>}
                </DialogActions>
            </Dialog>
        </div>
    );
}